// File: access-denied.ts
// Author: Dominique Fajardo
// Date: 1/10/2019
// Desc: Component for the access denied page.
// Other Contributors:

import { Component } from '@angular/core';

@Component({
    templateUrl: './access-denied.template.html',
    styleUrls: ['./access-denied.style.scss']
})
export class AccessDeniedComponent { }
